define.alias("shared/utils/formatters/ig-post-from-dynamo", "preview-grid/utils/formatters/ig-post-from-dynamo");